import { jsx as _jsx } from "react/jsx-runtime";
import { sizes } from '../../const/sizes';
import { Card } from '../Card/Card';
export const ExpansionTableRowCardWrapper = ({ cardVariant = 'grey', contentSpacing, backgroundColorOverride, children, }) => {
    return (_jsx(Card, { cardVariant: cardVariant, contentSpacing: contentSpacing, backgroundColorOverride: backgroundColorOverride, borderRadiusOverride: sizes.expansionTable.expansionTableRow.borderRadius, children: children }));
};
